<template>
  <div class="ImageTile">
    <img :src="imgURL" :alt="imgAlt" />
    <h3>{{title}}</h3>
    <p>{{text}}</p>
  </div>
</template>
<script>
export default {
  name: 'ImageTile',
  props: {
    imgFilename: String,
    imgAlt: String,
    title: String,
    text: String
  },
  components: {
  },
  computed: {
    imgURL () {
        return require('../assets/images/' + this.imgFilename);
    }
  },
  mounted () {
  },
  data () {
    return {
        
    };
  }
};
</script>
<style lang='scss' scoped>
  .ImageTile {
    display: flex;
    flex-direction: column;
      text-align: center;

    h3 {
      // text-align: center;
    }
  }
</style>
